/**
 * Static route placeholder for an Insights article.
 */
const PostSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-[var(--x3-page)] text-[var(--x3-text)]"
      aria-label="Loading article"
      aria-busy="true"
    >
      <div className="border-b border-[var(--x3-border)] bg-[var(--x3-surface)]">
        <div className="mx-auto max-w-4xl px-4 py-4 sm:px-6 lg:px-8">
          <div className="h-4 w-32 rounded bg-[var(--x3-surface-subtle)]" />
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-4 h-6 w-32 rounded bg-[var(--x3-surface-subtle)]" />

        <div className="mb-6 space-y-3">
          <div className="h-10 w-full rounded bg-[var(--x3-surface-subtle)]" />
          <div className="h-10 w-3/4 rounded bg-[var(--x3-surface-subtle)]" />
        </div>

        <div className="mb-8 flex gap-6 border-b border-[var(--x3-border)] pb-8">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-full bg-[var(--x3-surface-subtle)]" />
            <div className="space-y-2">
              <div className="h-4 w-24 rounded bg-[var(--x3-surface-subtle)]" />
              <div className="h-3 w-16 rounded bg-[var(--x3-surface-subtle)]" />
            </div>
          </div>
          <div className="h-4 w-24 rounded bg-[var(--x3-surface-subtle)]" />
          <div className="h-4 w-20 rounded bg-[var(--x3-surface-subtle)]" />
          <div className="h-4 w-20 rounded bg-[var(--x3-surface-subtle)]" />
        </div>

        <div className="mb-12 h-96 rounded-md bg-[var(--x3-surface-subtle)]" />

        <div className="mb-12 space-y-4">
          {[1, 2, 3, 4, 5, 6, 7, 8].map(item => (
            <div key={item} className="space-y-2">
              <div className="h-4 w-full rounded bg-[var(--x3-surface-subtle)]" />
              <div className="h-4 w-full rounded bg-[var(--x3-surface-subtle)]" />
              <div className="h-4 w-3/4 rounded bg-[var(--x3-surface-subtle)]" />
            </div>
          ))}
        </div>

        <div className="mb-12 border-b border-[var(--x3-border)] pb-12">
          <div className="mb-4 h-6 w-24 rounded bg-[var(--x3-surface-subtle)]" />
          <div className="flex gap-2">
            {[1, 2, 3, 4].map(item => (
              <div
                key={item}
                className="h-8 w-20 rounded bg-[var(--x3-surface-subtle)]"
              />
            ))}
          </div>
        </div>

        <div>
          <div className="mb-6 h-8 w-48 rounded bg-[var(--x3-surface-subtle)]" />
          <div className="grid gap-6 md:grid-cols-2">
            {[1, 2].map(item => (
              <div
                key={item}
                className="overflow-hidden rounded-md border border-[var(--x3-border)] bg-[var(--x3-surface)]"
              >
                <div className="h-40 bg-[var(--x3-surface-subtle)]" />
                <div className="space-y-2 p-4">
                  <div className="h-5 w-full rounded bg-[var(--x3-surface-subtle)]" />
                  <div className="h-4 w-24 rounded bg-[var(--x3-surface-subtle)]" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PostSkeleton
